import { isFunction } from 'lodash';
import { setIdle, setOverlayStatus, setVolume, state } from '@/shared/components/player/store';
import { OverlayStatus } from '@/shared/components/player/enums';
import { KeyCodeMap } from '@/shared/enums';
import fullscreenToggle from './fullscreen-toggle';

const VOLUME_STEP = 5;

export default {
  mixins: [fullscreenToggle],
  computed: {
    keyHandler() {
      return {
        Tab: {
          prevent: false,
          // Empty handler in order to trigger overlay status interaction on Tab key press
        },
        Space() {
          if (this.isTimeshiftEnabled && this.$window.isBodyFocused()) {
            this.togglePlay();
          }
        },
        ArrowUp() {
          setVolume(state.volume + VOLUME_STEP);
        },
        ArrowDown() {
          setVolume(state.volume - VOLUME_STEP);
        },
        ArrowLeft() {
          if (this.isTimeshiftEnabled) {
            this.seekBackward();
          }
        },
        ArrowRight() {
          if (this.isTimeshiftEnabled) {
            this.seekForward();
          }
        },
        KeyF: {
          handler() {
            this.toggleFullscreen('#player');
          },
          prevent: false,
        },
      };
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyboard);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyboard);
  },
  methods: {
    handleKeyboard(e) {
      const code = e.code || KeyCodeMap[e.keyCode];
      const keyHandler = this.keyHandler[code];

      if (keyHandler) {
        const handler = isFunction(keyHandler) ? keyHandler : keyHandler.handler;
        const prevent = isFunction(keyHandler) ? true : keyHandler.prevent;

        setOverlayStatus(OverlayStatus.INTERACTION);

        if (isFunction(handler)) {
          handler.call(this);
        }

        if (prevent) {
          e.preventDefault();
        }

        setIdle();
      }
    },
  },
};
